
export const performance = {
  beginSession(name: string, tag?: string) {
    console.time(name)
    return name
  },
  endSession(id: string) {
    console.timeEnd(id)
  }
}